import useSWR from 'swr';
import { useMemo } from 'react';

export default function useBalances() {
  const {
    data: balances,
    error,
    isLoading,
    mutate,
  } = useSWR('accounts/balances');

  const structured = useMemo(() => {
    const rawData = balances?.data || [];
    // Initialize with null for all expected types to ensure structure
    const defaults = {
      normal: null,
      reward: null,
      escrow: null,
      credit: null,
      cash_flow: null,
      deposit: null,
    };

    if (!Array.isArray(rawData)) return defaults;

    return rawData.reduce((acc, item) => {
      if (item?.type) {
        acc[item.type] = item;
      }
      return acc;
    }, defaults);
  }, [balances]);

  return {
    ...structured,
    all: balances?.data || [],
    isLoading,
    error,
    mutate,
  };
}
